import { render, staticRenderFns } from "./IconBadgeCheck.vue?vue&type=template&id=823173f6&scoped=true&"
import script from "./IconBadgeCheck.vue?vue&type=script&lang=js&"
export * from "./IconBadgeCheck.vue?vue&type=script&lang=js&"
import style0 from "./IconBadgeCheck.vue?vue&type=style&index=0&id=823173f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823173f6",
  null
  
)

export default component.exports